/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonPollInfo,
    JsonPollInfoFromJSON,
    JsonPollInfoFromJSONTyped,
    JsonPollInfoToJSON,
} from './JsonPollInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonPollInfo
 */
export interface ApiResultOfListOfJsonPollInfo {
    /**
     * 
     * @type {Array<JsonPollInfo>}
     * @memberof ApiResultOfListOfJsonPollInfo
     */
    data?: Array<JsonPollInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonPollInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonPollInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonPollInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonPollInfo
     */
    result?: ApiResultOfListOfJsonPollInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonPollInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonPollInfoFromJSON(json: any): ApiResultOfListOfJsonPollInfo {
    return ApiResultOfListOfJsonPollInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonPollInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonPollInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonPollInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonPollInfoToJSON(value?: ApiResultOfListOfJsonPollInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonPollInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

